<template>
  <div id="app">
    <NavigationBar/>
    <router-view />
  </div>
</template>

<script>
import NavigationBar from "@/components/NavigationBar";
export default {
  components: {
    NavigationBar
  },

  created() {
    document.title = 'HCL Policorp';
  }
}
</script>
<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

.hero-parallax .v-parallax__image {
  object-fit: cover;
  object-position: left center !important; /* keeps the logo on the left visible across breakpoints */
  left: 0 !important;
  right: auto !important;
  top: 50% !important;
  transform: translateY(-50%) !important; /* anchor left, stay vertically centered */
  min-width: 100% !important;
}

@media (max-width: 960px) {
  .hero-parallax {
    height: 320px !important;
  }
  .hero-parallax .v-parallax__image {
    object-position: center center !important; /* center the banner on small screens */
    left: 50% !important;
    transform: translate(-50%, -50%) !important;
  }
}
</style>
